const InfoContentStyle = {
  flex: 9,
  w: "100%",
};

const InfoStyle = {
  w: "100%",
  flex: 1,
  px: 50,
};

const ContentStyle = {
  w: "100%",
  flex: 10,
};

const CardArea = {
  justifyContent: "center" as "center",
  px: "$5",
  gap: "$4",
  w: "100%",
  h: "90%",
};

const shadow = {
  boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.25)",
};

const cardButton = {
  bg: "#FFF",
  py: "$5",
  px: "$4",
  flex: 1,
  borderRadius: 12,
  ...shadow,
};

export {
  CardArea,
  cardButton, ContentStyle, InfoContentStyle,
  InfoStyle, shadow
};
